import { OnDestroy } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialogConfig } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomAuthenticationService } from "@app/auth/services/custom-authentication.service";
import { ServiceInjector } from "@app/service-injector.module";
import { Subject, Subscription } from "rxjs";
import { DialogBoxService } from "../components/alerts/dialog-box-service";
import { PermissionsType } from "../enums/permissions-type.enum";

export abstract class AppScreenBase implements OnDestroy {
    
    dialogConfig: MatDialogConfig;
    onClosed = new Subject();
    readonly subscriptions = new Array<Subscription>();
    public appDialog: DialogBoxService;
    readonly activeRoute: ActivatedRoute;
    readonly router: Router;
    readonly formBuilder: FormBuilder;
    readonly appAuth: CustomAuthenticationService;
    protected isSnackbarDismissible: boolean = true;

    constructor() {

        this.appDialog = ServiceInjector.get(DialogBoxService);
        this.router = ServiceInjector.get(Router);
        this.activeRoute = ServiceInjector.get(ActivatedRoute);
        this.appAuth = ServiceInjector.get(CustomAuthenticationService);

        this.dialogConfig = new MatDialogConfig();
        this.dialogConfig.disableClose = true;
        this.dialogConfig.autoFocus = true;
        this.dialogConfig.hasBackdrop = true;
        this.dialogConfig.height = "90vh";
        this.dialogConfig.width = "92vw";
        this.dialogConfig.maxWidth = "100vw";
    }

    ngOnDestroy() {
        this.dialogConfig.data = null;
        if (this.isSnackbarDismissible) this.appDialog.dismissSnackbar();
        this.onClosed.next();
        this.onClosed.complete();
        for (const subscription of this.subscriptions) subscription.unsubscribe();

        this.onClose();
    }

    protected abstract onClose(): void;

    validateForm(form: FormGroup | FormArray): boolean {
        let isInvalid = form.invalid;
        if (isInvalid) {
            Object.keys(form.controls).forEach(field => {
                const control = form.get(field);
                if (control instanceof FormControl) {
                    control.markAsTouched({ onlySelf: true });
                } else if (control instanceof FormGroup) {
                    this.validateForm(control);
                } else if (control instanceof FormArray) {
                    (control as FormArray).controls.forEach((group) => this.validateForm(group as FormGroup));
                }
            }
            );
        }
        return !isInvalid;
    }

    hasPermission(permission: PermissionsType) {
       return this.appAuth.hasPermission(permission);
    }

    hasSomePermission(permissions: PermissionsType[]) {
        let hasPermission: boolean = false;
        for (let index = 0; index < permissions.length; index++) {
            const item = permissions[index];
            if (this.hasPermission(item) == true){
                hasPermission = true;
                break;
            }
        }
        return hasPermission;
    }

    hasAllPermissions(permissions: PermissionsType[]) {
        let hasPermission: boolean = false;
        for (let index = 0; index < permissions.length; index++) {
            const item = permissions[index];
            if (this.hasPermission(item) == true){
                hasPermission = true;
            } else {
                hasPermission = false;
                break;
            }
        }
        return hasPermission;
    }

    get isMasterClientePermission() {
        return this.hasPermission(PermissionsType.master);
    }
    
    get isMasterBoPermission() {
        return this.hasPermission(PermissionsType.masterBo);
    }

}

/** Uso de dialogos e snackbar */
/// this.appDialog.snackbarUtil.showSuccess("Mensagem de sucesso");

/** Exemplo de uso do onClosed em Observables */
/// meuObservavle
///     .pipe(takeUntil(this.onClosed)) // unsubscribe o observable no ngOnDestroy da tela
///     .subscribe(value => {
///     console.log(value);
///   });

/** Exemplo de uso de lista de subscriptions */
/// this.subscriptions.push(
///     meuObservable
///      .subscribe(value => {
///      console.log(value);
///    })
/// );